import React from 'react';

function AudioPlayer({uri}) {
    return (
        <audio src={uri} preload="auto" controls></audio>
    );
}

export default AudioPlayer;
